import { AccordionDetails, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import {
  FlatAccordion,
  FlatAccordionSummary,
} from 'src/components/FlatAccordion/flat-accordion';
import useCustomAttributesUIStore from 'src/store/custom-attributes-ui';

interface CollapsibleGroupProps {
  scopeKey: string;
  groupKey: string;
  label: string;
  children: ReactNode;
}

export const CollapsibleGroup = ({
  scopeKey,
  groupKey,
  label,
  children,
}: CollapsibleGroupProps) => {
  const collapsed = useCustomAttributesUIStore((s) =>
    (s.collapsedGroupsByScope[scopeKey] ?? []).includes(groupKey),
  );
  const setGroupCollapsed = useCustomAttributesUIStore((s) => s.setGroupCollapsed);

  return (
    <FlatAccordion
      expanded={!collapsed}
      onChange={(_, expanded) => setGroupCollapsed(scopeKey, groupKey, !expanded)}
      disableGutters
    >
      <FlatAccordionSummary
        expandIcon={<DynamicIcon name="chevron-down" library="lucide" />}
        sx={{ pl: 2, pr: '4px' }}
      >
        <Typography variant="subtitle2" sx={{ alignSelf: 'center' }}>
          {label}
        </Typography>
      </FlatAccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Stack gap={0.5}>{children}</Stack>
      </AccordionDetails>
    </FlatAccordion>
  );
};
